import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface WorkspaceState {
  onSearchUsers: (search: string) => Promise<any[]>;
  setOnSearchUsers: (func: WorkspaceState['onSearchUsers']) => void;

  onCreateWorkspace: (arg: {
    name: string;
    privacy: string;
    members: string[];
    emails: string[];
    icon?: {
      id?: any;
      type?: string;
    };
    description?: string;
  }) => Promise<any>;
  setOnCreateWorkspace: (func: WorkspaceState['onCreateWorkspace']) => void;
}

export const useWorkspace = create<WorkspaceState, [['zustand/devtools', WorkspaceState]]>(
  devtools((set) => ({
    onSearchUsers: async () => [],
    setOnSearchUsers: (func) => set({ onSearchUsers: func }),

    onCreateWorkspace: async () => false,
    setOnCreateWorkspace: (func) => set({ onCreateWorkspace: func }),
  }))
);
